export default "__VITE_ASSET__D6C$ieKk__"